import PointMap from "../ext/PointMap";
import GroupingAction from "../ext/GroupingAction";
import { networkName, locality } from "../../../util/formatter";

export default {
  slug: "points",
  endpoint: "points/",
  titleKey: "points_title",
  columns: [
    { label: "f_network", format: row => networkName(null, row) },
    { field: "name", label: "f_name" },
    { field: "address", label: "f_address" },
    { field: "code", label: "f_code" },
    { label: "f_locality", format: row => locality(null, row) },
  ],
  filters: [
    { name: "network", entity: "network" },
    { name: "locality__county", entity: "county", defaultRegion: true },
    { name: "locality", entity: "locality", scopeBy: "locality__county" },
  ],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "code", type: "text", label: "f_code" },
    { name: "address", type: "text", label: "f_address", wide: true },
    { name: "network", type: "entity", entity: "network", label: "f_network" },
    { name: "category", type: "entity", entity: "categories_point", label: "f_category" },
    { name: "locality", type: "entity", entity: "locality", label: "f_locality" },
    { name: "location", type: "location", label: "f_location", wide: true },
    { name: "minutes_recommended", type: "number", label: "f_minutes" },
    { name: "responsible_merchandiser", type: "entity", entity: "merchandiser", label: "f_merchandiser" },
    { name: "responsible_supervisors", type: "entity", entity: "supervisor", isMulti: true, label: "f_supervisors" },
    { name: "is_active", type: "checkbox", label: "f_is_active" },
    { name: "is_available_for_task_creation", type: "checkbox", label: "f_available_tasks" },
  ],
  sections: [
    { title: "sec_basic", fields: ["name", "code", "network", "category"] },
    { title: "sec_location", fields: ["address", "locality", "location"] },
    { title: "sec_assignment", fields: ["responsible_merchandiser", "responsible_supervisors"] },
    { title: "sec_options", fields: ["minutes_recommended", "is_active", "is_available_for_task_creation"] },
  ],
  detailPanel: PointMap,
  bulkActions: [{ key: "grouping", Component: GroupingAction }],
  softDelete: true,
};
